import styled from 'styled-components';

import GlintsContainer from 'src/components/GlintsContainer';

export const TermsPageContainer = styled.div`
  text-align: justify;
`;

export const MarkdownGlintsContainer = styled(GlintsContainer)`
  margin-top: 85px;
  margin-bottom: 48px;

  p,
  h1,
  h2,
  li {
    margin-bottom: 1rem;
  }

  pre {
    white-space: pre-wrap;
  }

  ol {
    list-style: none;
    counter-reset: item;

    > li {
      counter-increment: item;
    }

    > li:before {
      content: counters(item, '.') '. ';
      margin-right: 4px;
      float: left;
    }
  }
`;
